<script setup lang="ts">
import { RouterView } from 'vue-router'
import { useRoute } from 'vue-router';
import Header from "@/widgets/Header/ui/Header.vue";
import Footer from "@/widgets/Footer/ui/Footer.vue";
import { computed } from 'vue'

const route = useRoute();
const hideTopImage = computed(() => route.meta.hideHeaderImage);
</script>

<template>
  <div class="app-layout">
    <div v-if="!hideTopImage" class="top-image-container">
      <img src="/images/header_image.webp" alt="" class="top-bg">
    </div>
    <Header/>
    <main class="content">
      <RouterView :key="route.fullPath"/>
    </main>
    <Footer/>
  </div>
</template>

<style scoped>
.app-layout {
  position: relative;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.top-image-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
  z-index: -1;
  overflow: auto;
}

.top-bg {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

@media (max-width: 768px) {
  .top-image-container {
    height: 30vh;
  }
  .content-wrapper {
    margin-top: 15vh;
  }
}

.content {
  flex: 1;
}
</style>
